import { MenuPointAction } from '@agilox/common';
import { MenuPoint, NavColor, NavColors } from '@agilox/ui-common';
import { Component, computed, input, output } from '@angular/core';

@Component({
	selector: 'ui-nav-list',
	templateUrl: './nav-list.component.html',
	standalone: false,
})
export class NavListComponent {
	items = input<MenuPoint[] | undefined>(undefined);
	openItem = input<MenuPoint | undefined>(undefined);
	navColor = input<NavColor>(NavColors.Dark);
	beta = input<boolean>(false);
	betaTranslation = input<string>('Beta');
	currentUrl = input<string>('');

	menuPointAction = output<MenuPointAction>();
	closeMenu = output<void>();

	topItems = computed(() => {
		return this.items()?.filter((item) => !item.position || item.position === 'top') || [];
	});

	bottomItems = computed(() => {
		return this.items()?.filter((item) => item.position === 'bottom') || [];
	});

	handleEntryClick(menuPoint: MenuPoint) {
		this.menuPointAction.emit({ click: true, menuPoint: menuPoint });
	}
	handleMouseEnter(menuPoint: MenuPoint) {
		if (menuPoint.submenus) {
			this.menuPointAction.emit({ click: false, menuPoint: menuPoint });
		} else {
			this.closeMenu.emit();
		}
	}

	private stripQueryParams(url: string): string {
		return url ? url.split('?')[0] : url;
	}

	childMenuPointActive(menuPoint: MenuPoint) {
		let submenus: MenuPoint[] = menuPoint.submenus || [];
		const urlWithoutParams = this.stripQueryParams(this.currentUrl());
		return submenus.some(
			(submenu: MenuPoint) => submenu.active || (submenu.url === urlWithoutParams && !!submenu.url)
		);
	}

	isMenuPointActive(menuPoint: MenuPoint): boolean {
		const urlWithoutParams = this.stripQueryParams(this.currentUrl());
		return (
			(menuPoint.url && urlWithoutParams?.includes(menuPoint.url)) ||
			menuPoint.active ||
			this.childMenuPointActive(menuPoint)
		);
	}

	getGlobalIndex(item: MenuPoint, isTopItem: boolean): number {
		if (isTopItem) {
			return this.topItems().indexOf(item);
		} else {
			return this.topItems().length + this.bottomItems().indexOf(item);
		}
	}
}
